import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCuronAppLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg width={56} height={56} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={56} height={56} rx={15} fill="#008E44" />

    <mask
      id="CuronAppLogo_svg__a"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={12}
      y={13}
      width={32}
      height={31}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.134 13.563H43.42v29.52H12.134v-29.52Z"
        fill="#fff"
      />
    </mask>

    <g mask="url(#CuronAppLogo_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m38.54 27.466-6.463 6.684-4.3 4.447-4.3-4.447-1.65-1.706a8.92 8.92 0 0 0 5.018-1.944c.278.099.575.155.886.155 1.514 0 2.74-1.27 2.74-2.835 0-1.566-1.226-2.835-2.74-2.835-1.514 0-2.741 1.27-2.741 2.835 0 .043.004.084.006.127a5.9 5.9 0 0 1-3.726 1.328c-3.343 0-6.053-2.803-6.053-6.26 0-3.458 2.71-6.261 6.053-6.261 1.406 0 2.698.497 3.726 1.328-.002.042-.006.083-.006.126 0 1.565 1.227 2.834 2.74 2.834 1.515 0 2.742-1.269 2.742-2.834l-.003-.054a5.906 5.906 0 0 1 3.814-1.4c3.343 0 6.054 2.803 6.054 6.26 0 1.73-.701 3.319-1.797 4.452Zm-4.257-13.904a8.905 8.905 0 0 0-5.6 1.987 2.65 2.65 0 0 0-.952-.179c-.311 0-.61.056-.889.155a8.904 8.904 0 0 0-5.572-1.963c-5.046 0-9.136 4.231-9.136 9.45a9.583 9.583 0 0 0 2.7 6.705l6.462 6.685 6.46 6.681.02-.02.02.02 6.461-6.681 6.464-6.684a9.664 9.664 0 0 0 2.699-6.706c0-5.219-4.09-9.45-9.137-9.45Z"
        fill="#fff"
      />
    </g>
  </svg>
);

const Memo = memo(SvgCuronAppLogo);

export default Memo;
